import { render, staticRenderFns } from "./SalesOrderViewAddDeliveryForm.vue?vue&type=template&id=4e8c0e14&scoped=true"
import script from "./SalesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderViewAddDeliveryForm.vue?vue&type=style&index=0&id=4e8c0e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c0e14",
  null
  
)

export default component.exports